import { Component, ChangeDetectionStrategy } from '@angular/core';
import { availableServiceProvider, ServiceProvider } from './service-provider-list.config';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'customer-app-service-provider-list',
  templateUrl: './service-provider-list.component.html',
  styleUrls: ['./service-provider-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe]
})
export class ServiceProviderListComponent {
  public readonly serviceProvider: ServiceProvider[] = availableServiceProvider;
  public readonly columnWidths: string[] = ['5%', '15%', '15%', '20%', '15%', '30%'];
}
